// @ts-nocheck

import { request } from '../../context';
import type { ApiOptions } from '../../context';
import type {
    GetAiAgentsByIdParam,
    BaseResponseAiAgentFoundResponse,
    PutAiAgentsByIdParam,
    PutAiAgentsByIdBody,
    BaseResponseVoid,
    DeleteAiAgentsByIdParam,
} from '../../types';

/**
 * findById
 *
 * @export
 * @tags ai-agent-controller
 * @link [GET] /aiAgents/{id}
 * @param id
 */
export function getAiAgentsById(
    options: ApiOptions<GetAiAgentsByIdParam, never> & { segments: GetAiAgentsByIdParam }
): Promise<BaseResponseAiAgentFoundResponse> {
    return request<never, GetAiAgentsByIdParam, never>('/aiAgents/{id}', {
        ...options,
        method: 'get',
        __$requestCalleeName: 'getAiAgentsById',
    });
}

/**
 * update
 *
 * @export
 * @tags ai-agent-controller
 * @link [PUT] /aiAgents/{id}
 * @param id
 */
export function putAiAgentsById(
    data: PutAiAgentsByIdBody,
    options: ApiOptions<PutAiAgentsByIdParam, never> & { segments: PutAiAgentsByIdParam }
): Promise<BaseResponseVoid> {
    return request<PutAiAgentsByIdBody, PutAiAgentsByIdParam, never>('/aiAgents/{id}', {
        ...options,
        data,
        method: 'put',
        __$requestCalleeName: 'putAiAgentsById',
    });
}

/**
 * deleteById
 *
 * @export
 * @tags ai-agent-controller
 * @link [DELETE] /aiAgents/{id}
 * @param id
 */
export function deleteAiAgentsById(
    options: ApiOptions<DeleteAiAgentsByIdParam, never> & { segments: DeleteAiAgentsByIdParam }
): Promise<BaseResponseVoid> {
    return request<never, DeleteAiAgentsByIdParam, never>('/aiAgents/{id}', {
        ...options,
        method: 'delete',
        __$requestCalleeName: 'deleteAiAgentsById',
    });
}

export const meta = [
    { tags: ['ai-agent-controller'], path: '/aiAgents/{id}', method: 'get' },
    { tags: ['ai-agent-controller'], path: '/aiAgents/{id}', method: 'put' },
    { tags: ['ai-agent-controller'], path: '/aiAgents/{id}', method: 'delete' },
];
